import {ReactNode, useContext} from 'react';

import {Grid, SxProps, Typography} from '@mui/material';

import {bodyPdf, pdfH4} from '../styles';

import {
  CommentIcon,
  HandHoldingHeartIcon,
  HandshakeIcon,
  LaptopIcon,
  LightBulbIcon,
  PuzzlePieceIcon,
  UserAstronautIcon,
  UsersIcon,
} from '../../../../assets/company_culture_house';
import {EmpionPaper} from '../../../../components/EmpionPaper/EmpionPaper';
import {LanguageContext} from '../../../../contexts/LanguageContext/LanguageContext';
import {greenColors, orangeColors} from '../../../../layouts/theme/designSystem';
import {CultureHouseElement} from '../../culture/dashboard/types/CultureHouseTypes';

interface Props {
  cultureHouse: CultureHouseElement[];
}

export const CultureCardPdf = ({cultureHouse}: Props) => {
  const currentLanguage = useContext(LanguageContext);

  const paperStyles: SxProps = {
    minHeight: '220px',
    width: '330px',
    borderRadius: '16px',
    p: 2,
    height: '100%',
  };

  const pillarIcons: {[key: string]: ReactNode} = {
    new_work_and_hybrid_work: <LaptopIcon fill={greenColors[700]} aria-label='laptop icon' />,
    interaction_and_empathy: <HandHoldingHeartIcon fill={greenColors[700]} aria-label='hand holding heart icon' />,
    development_and_communication: <CommentIcon fill={greenColors[700]} aria-label='comment icon' />,
    performance_and_organization: <PuzzlePieceIcon fill={greenColors[700]} aria-label='puzzle piece icon' />,
    leadership_and_team: <UsersIcon fill={greenColors[700]} aria-label='three users icon' />,
    purpose_and_value: <HandshakeIcon fill={greenColors[700]} aria-label='handshake icon' />,
    innovation_and_convention: <LightBulbIcon fill={greenColors[700]} aria-label='lightbulb icon' />,
    appearance_and_risk: <UserAstronautIcon fill={greenColors[700]} aria-label='austronaut icon' />,
  };

  return cultureHouse.map((pillar) => (
    <Grid item key={pillar.resourceId}>
      <EmpionPaper sx={{...paperStyles, backgroundColor: orangeColors[5]}}>
        {pillarIcons[pillar.key]}
        <Typography variant='h4' sx={pdfH4} mb={1}>
          {pillar.pillarTitle[currentLanguage]}
        </Typography>
        <Typography variant='body1' sx={bodyPdf}>
          {pillar.pillarDescription[currentLanguage]}
        </Typography>
      </EmpionPaper>
    </Grid>
  ));
};
